'use strict';

function CreatePendingSpendingController (
    $scope,
    $mdDialog,
    registries
) {
    'ngInject';

    $scope.btnDisabled = true;
    $scope.registries = registries;

    $scope.save = function() {
        if ($scope.form.$valid) {
            $mdDialog.hide({
                comments: $scope.comments,
                amount: $scope.amount,
                registry: this.selectedRegistry
            });
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };

    $scope.querySearch = function(text) {
        let matches = registries.filter(r => {
            let nameMatches = r.name.toLowerCase()
                .indexOf(text.toLowerCase()) > -1;
            return nameMatches;
        });
        return matches;
    };

}

export default CreatePendingSpendingController;
